import get from 'lodash/get';
import defaultFields from 'store/Services/fields';

// eslint-disable-next-line import/prefer-default-export
export const selectFields = (state) => {
  const fields = get(state, 'preferences.services_table', defaultFields);
  const excludedFields = ['workspace_name'];

  const newFields = {};
  Object.keys(defaultFields).forEach((key) => {
    if (!excludedFields.includes(key)) {
      const defaultField = defaultFields[key];
      newFields[key] = { ...defaultField, ...get(fields, key, defaultField) };
    }
  });

  return newFields;
};
